/** e.g. "17 May 2026" — matches Telegram digest header (Asia/Kuala_Lumpur). */
export const formatReminderDigestDateMalaysia = (date = new Date()) =>
  new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kuala_Lumpur",
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(date);

export const REMINDER_NOTIFICATION_TIMES = [
  { value: "08:00", label: "8:00 AM" },
  { value: "09:00", label: "9:00 AM" },
  { value: "10:00", label: "10:00 AM" },
];

// 1 = Mon .. 7 = Sun; [] = daily (every day)
export const REMINDER_DAY_OPTIONS = [
  { value: 1, label: "Mon" },
  { value: 2, label: "Tue" },
  { value: 3, label: "Wed" },
  { value: 4, label: "Thu" },
  { value: 5, label: "Fri" },
  { value: 6, label: "Sat" },
  { value: 7, label: "Sun" },
];

/** Section labels (Notify me about, Locations, Time, …) */
export const reminderSectionTitleSx = {
  mb: 0.5,
  color: "#000",
  fontWeight: 600,
  fontSize: "15px",
};

/** Helper copy directly under a section title */
export const reminderSectionSubtitleSx = {
  fontSize: "14px",
  lineHeight: 1.45,
  color: "#666",
};

/** Counts and secondary labels in a section header row */
export const reminderSectionMetaSx = {
  fontSize: "14px",
  color: "#888",
};

/** Tappable option card primary line */
export const reminderOptionCardTitleSx = {
  fontSize: "14px",
  fontWeight: 600,
  color: "#000",
};

/** Tappable option card secondary line */
export const reminderOptionCardSubtitleSx = {
  fontSize: "14px",
  lineHeight: 1.4,
  color: "#666",
};

/** Inline field label (e.g. area search trigger) */
export const reminderFieldLabelSx = {
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: 1.4,
  color: "#000",
};

/** Inline field hint under a label */
export const reminderFieldHintSx = {
  fontSize: "12px",
  lineHeight: 1.3,
  color: "#aaa",
};

/** Sticky page header title */
export const reminderPageTitleSx = {
  fontSize: "18px",
  fontWeight: 600,
  color: "#000",
};

/** Centered hero / success screen title */
export const reminderHeroTitleSx = {
  fontSize: "20px",
  fontWeight: 600,
  color: "#000",
};

/** Centered hero / success screen body */
export const reminderHeroSubtitleSx = {
  fontSize: "14px",
  color: "#555",
  lineHeight: 1.6,
};

/** Validation and inline errors */
export const reminderInlineErrorSx = {
  fontSize: "14px",
  fontWeight: 500,
  color: "#dc2626",
};

export const reminderChipSx = (selected, disabled = false) => ({
  cursor: disabled ? "not-allowed" : "pointer",
  background: "#fff",
  color: disabled ? "#999" : "#000",
  borderRadius: "20px",
  px: 2,
  py: 1,
  height: "36px",
  display: "flex",
  alignItems: "center",
  fontSize: "14px",
  fontWeight: 500,
  whiteSpace: "nowrap",
  flexShrink: 0,
  transition: "all 0.2s ease",
  border: selected
    ? "1px solid #000"
    : disabled
      ? "1px solid #e0e0e0"
      : "1px solid #ddd",
  opacity: disabled ? 0.6 : 1,
  "&:hover": {
    bgcolor: disabled ? "transparent" : "#fff",
  },
});
